
import { useNavigate } from 'react-router-dom';

export default function StudentsHeroSection() {
  const navigate = useNavigate();

  return (
    <section 
      className="relative py-20 bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 48, 135, 0.8), rgba(0, 48, 135, 0.8)), url('https://public.readdy.ai/ai/img_res/60fde4696b530879a940010ebeba32a3.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Students of CPVA
          </h1>
          <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed">
            Empowering the next generation of pharmacy and veterinary professionals through collaboration, education, and shared excellence
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => navigate('/membership')}
              className="bg-white text-blue-900 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-blue-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              Join CPVA Today
            </button>
            <button
              onClick={() => navigate('/programs')}
              className="border-2 border-white text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-white hover:text-blue-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              Explore Programs
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
